import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-registration-achieva.component.scss";
var FormItemRegistrationAchieva = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemRegistrationAchieva, _super);
    function FormItemRegistrationAchieva(element) {
        return _super.call(this, element) || this;
    }
    FormItemRegistrationAchieva.prototype.init = function () {
        // this.form = this.element.querySelector("form") as HTMLFormElement;
        // this.applyForm = this.element.querySelector("form") as HTMLFormElement;
        this.flexibleFuneralPlanCmbForm = this.element.querySelector("form");
        this.applyFormRadio = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.flexibleFuneralPlanCmbSubmit = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        this.hiddenEmail = this.element.querySelector("input[name=email]");
        this.hiddenRecipient = this.element.querySelector("input[name=recipient]");
        this.dateOfBirth = this.element.querySelector(".js-date-of-death-container");
        // this.employmentStatusContainer =
        // 	this.flexibleFuneralPlanCmbForm.querySelector(
        // 		"input[name=employment-status]"
        // 	);
        // this.achievaExchangeContainer =
        // 	this.flexibleFuneralPlanCmbForm.querySelector(
        // 		"name[name=achieva-exchange]"
        // 	);
        // this.employmentStatusContainer.classList.add("form__group--hidden");
        // this.achievaExchangeContainer.classList.add("form__group--hidden");
        // display views
        if (this.flexibleFuneralPlanCmbSubmit) {
            this.displayLoader = this.flexibleFuneralPlanCmbForm.querySelector(".form-container__loader");
            this.displayFields = this.flexibleFuneralPlanCmbForm.querySelector(".form-container__fields");
            this.displaySuccess = this.flexibleFuneralPlanCmbForm.querySelector(".form-container__success");
            this.displayError = this.flexibleFuneralPlanCmbForm.querySelector(".form-container__error");
        }
        // this.queryParams = new URLSearchParams(window.location.search);
        // Radio button
        this.donarReceipient === "";
        // this.dateOfDeathField = this.element.querySelector('input[name=date-of-death]');
        this.causeOfDeathRadioButtons = Array.from(this.element.querySelectorAll("input[name=donar-receipient]"));
        this.causeOfDeathContainer =
            this.element.querySelector(".js-donar-receipient");
        this.causeOfDeathContainer
            .querySelectorAll("input[name=donar-receipient]")
            .forEach(function (el) {
            el.classList.add("js-donar-receipient__radio-group");
        });
        this.causeOfDeathField = Array.from(this.element.querySelectorAll("input[name=donar-receipient]"));
        // New code preferd time to contact
        this.willAttendEvent = "";
        this.preferedMethodOfContactRadioButtons = Array.from(this.element.querySelectorAll("input[name=will-attend-event]"));
        this.preferedMethodOfContactContainer = this.element.querySelector(".js-will-attend-event");
        this.preferedMethodOfContactContainer
            .querySelectorAll("input[name=preferred-contact-method]")
            .forEach(function (el) {
            el.classList.add("js-will-attend-event__radio-group");
        });
        this.preferedMethodOfContactField = Array.from(this.element.querySelectorAll("input[name=will-attend-event]"));
        this.employmentStatusContainer = this.element.querySelector(".js-employment-status-container");
        this.achievaExchangeContainer = this.element.querySelector(".js-achieva-exchange-container");
        // this.doneBtnNode = this.element.querySelector(".done-btn");
        // this.doneBtn = this.element.querySelectorAll(".done-btn");
        this.doneBtn = this.element.querySelectorAll(".done-btn");
        this.closeButton = this.element.querySelectorAll(".done-btn");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
    };
    FormItemRegistrationAchieva.prototype.bindEvents = function () {
        var _this = this;
        this.flexibleFuneralPlanCmbSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var formFields = _this.flexibleFuneralPlanCmbForm.querySelectorAll("input, select,textarea");
                _this.validationService.validate(formFields);
                var valid = Array.from(_this.flexibleFuneralPlanCmbForm.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.actionForm(_this.flexibleFuneralPlanCmbForm);
                }
                // let reCaptchaValid = false;
                // let reCaptchaFormField =
                // 	this.flexibleFuneralPlanCmbForm.querySelector(
                // 		".g-recaptcha"
                // 	);
                // let formRecaptchaResponseField: any =
                // 	this.flexibleFuneralPlanCmbForm.querySelector(
                // 		".g-recaptcha-response"
                // 	);
                // reCaptchaValid =
                // 	formRecaptchaResponseField.value != null &&
                // 	formRecaptchaResponseField.value != ""
                // 		? true
                // 		: false;
                // this.validationService.validateReCaptcha(
                // 	reCaptchaValid,
                // 	reCaptchaFormField
                // );
                // const valid = Array.from(
                // 	this.flexibleFuneralPlanCmbForm.querySelectorAll(
                // 		".form__group--error"
                // 	)
                // );
                // if (valid.length == 0 && reCaptchaValid) {
                // 	this.actionForm(this.flexibleFuneralPlanCmbForm);
                // }
            });
        });
        this.applyFormRadio.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var identificationField = _this.flexibleFuneralPlanCmbForm.querySelector("input[name=identification]");
                var identificationType = evt.value;
                _this.idType = identificationType;
                if (identificationType === "said") {
                    identificationField.classList.remove("form__input--identification--passport");
                    identificationField.classList.add("form__input--identification");
                    identificationField.placeholder = "Enter you South Africa ID number";
                    identificationField.type = "number";
                }
                else {
                    identificationField.classList.remove("form__input--identification");
                    identificationField.classList.add("form__input--identification--passport");
                    identificationField.placeholder = "Enter you Passport number";
                    identificationField.type = "text";
                }
            });
        });
        this.doneBtn.forEach(function (item) {
            item.addEventListener("click", function (event) {
                _this.resetForm();
                _this.analyticsService.dtmFormAbandon();
            });
        });
        // Event Listner for Donor
        this.causeOfDeathRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var causeOfDeathType = evt.value;
                _this.donarReceipient = causeOfDeathType;
                if (causeOfDeathType != "Donor") {
                    _this.employmentStatusContainer.classList.remove("form__group--hidden");
                    _this.achievaExchangeContainer.classList.remove("form__group--hidden");
                }
                else {
                    _this.employmentStatusContainer.classList.add("form__group--hidden");
                    _this.achievaExchangeContainer.classList.add("form__group--hidden");
                }
            });
        });
        // Event Listner for WillAttend
        this.preferedMethodOfContactRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var preferedMethodForCall = evt.value;
                _this.willAttendEvent = preferedMethodForCall;
            });
        });
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        this.closeButton.forEach(function (item) {
            item.addEventListener("click", function (event) {
                _this.closeModal();
            });
        });
        /// New added forms and reset forms
        if (this.flexibleFuneralPlanCmbSubmit) {
            var _formFields = Array.from(this.flexibleFuneralPlanCmbForm.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        //this.validationService.addError();
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
            // Reset the form
            this.flexibleFuneralPlanCmbForm.addEventListener("custom_form_reset_event", function (e) {
                var valid = Array.from(_this.flexibleFuneralPlanCmbForm.querySelectorAll(".form__group--error"));
                valid.map(function (pElem) {
                    pElem.classList.remove("form__group--error");
                    var errorMessage = pElem.querySelector(".form__group--error_message");
                    if (errorMessage) {
                        errorMessage.remove();
                    }
                });
                _this.resetForm();
            }, false);
        }
    };
    // Radio button validation
    FormItemRegistrationAchieva.prototype.validateCauseOfDeath = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var causeOfDeathRadiosGroup = this.causeOfDeathRadioButtons[0].closest(".form__group");
        selectionArray.push(causeOfDeathRadiosGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!causeOfDeathRadiosGroup.classList.contains("form__group--hidden")) {
            if (this.donarReceipient === undefined || "") {
                isValid = false;
                causeOfDeathRadiosGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                causeOfDeathRadiosGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemRegistrationAchieva.prototype.validatePreferedMethodToContact = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var methodOfContactRadioGroup = this.preferedMethodOfContactRadioButtons[0].closest(".form__group");
        selectionArray.push(methodOfContactRadioGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!methodOfContactRadioGroup.classList.contains("form__group--hidden")) {
            if (this.willAttendEvent === "" || undefined) {
                isValid = false;
                methodOfContactRadioGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                methodOfContactRadioGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemRegistrationAchieva.prototype.closeModal = function () {
        this.analyticsService.dtmFormAbandon();
        this.resetForm();
    };
    FormItemRegistrationAchieva.prototype.resetForm = function () {
        if (this.flexibleFuneralPlanCmbForm) {
            this.flexibleFuneralPlanCmbForm.reset();
            var formContainerFields = this.element.querySelector(".form-container__fields");
            var formContainerThankyou = this.element.querySelector(".form-container__success");
            formContainerThankyou.classList.remove("active");
            formContainerFields.classList.remove("hidden");
        }
        this.showDisplayView("");
    };
    FormItemRegistrationAchieva.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemRegistrationAchieva.prototype.actionForm = function (form) {
        var _this = this;
        if (!this.validateCauseOfDeath()) {
            return true;
        }
        if (!this.validatePreferedMethodToContact()) {
            return true;
        }
        //New change
        // let gRecaptcha: any = form.querySelector(".g-recaptcha");
        // let formRecaptchaResponseItem: any = form.querySelector(
        // 	".g-recaptcha-response"
        // );
        // let recaptcha: any = this.element.querySelector(
        // 	"textarea[name=g-recaptcha-response]"
        // );
        // let siteKey: any = gRecaptcha.getAttribute("data-sitekey");
        this.showDisplayView("loader");
        var name = form.querySelector("input[name=first-name]");
        var surname = form.querySelector("input[name=surname-name]");
        var contactNumber = form.querySelector("input[name=phone-number]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var ageRange = form.querySelector("select[name=age-range]");
        var employmentStatus = form.querySelector("select[name=employment-status]");
        var exchageBestAssitYourNextFirst = form.querySelector("select[name=achieva-exchange]");
        var _dateOfBirth = form.querySelector("input[name=date-of-birth]");
        var dateParts = _dateOfBirth.value.split("/");
        var newDate = "";
        if (dateParts.length > 0 && dateParts.length <= 3) {
            newDate = dateParts[2] + "/" + dateParts[1] + "/" + dateParts[0];
        }
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        // loader.classList.add("active");
        // fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/leadsutils/registerachievaevent";
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        var postData = {
            // New data fields added below
            fullName: name.value + " " + surname.value,
            donarOrReceipient: this.donarReceipient,
            willAttendEvent: this.willAttendEvent,
            // identificationNumber: identificationNumber.value,
            identificationNumber: newDate,
            ageRange: ageRange.value,
            contactNumber: contactNumber.value,
            emailAddress: emailAddress.value,
            employmentStatus: employmentStatus.value,
            exchageBestAssitYourNextFirst: exchageBestAssitYourNextFirst.value,
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
        };
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            //console.log("!response.data", response.data.toString());
            // loader.classList.remove("active");
            if (!response.data ||
                response.data.toString().includes("invalid")) {
                // analyticsService.dtmRecordSiteError(
                // 	"noerrorcode|invalid response"
                // );
                analyticsService.dtmRecordSiteError("noerrorcode | invalid response | " + url);
                _this.showDisplayView("error");
                // this.showDisplayView(`success`);
            }
            else {
                if (response.data.toString().includes("valid")) {
                    if (response.code) {
                        analyticsService.dtmFormComplete("complete", response.code, false, "", emailAddress.value, contactNumber.value);
                    }
                    else if (response.status) {
                        analyticsService.dtmFormComplete("complete", response.status, false, "", emailAddress.value, contactNumber.value);
                    }
                    else {
                        analyticsService.dtmFormComplete("complete", "200", false, "", emailAddress.value, contactNumber.value);
                    }
                    _this.showDisplayView("success");
                }
                else if (!response.data.captchaResponse) {
                    _this.displayFields.classList.remove("hidden");
                    _this.displayLoader.classList.add("hidden");
                }
                else {
                    analyticsService.dtmRecordSiteError("noerrorcode | invalid response | " + url);
                    _this.showDisplayView("error");
                }
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            // loader.classList.remove("active");
            // fieldsContainer.classList.remove("hidden");
            _this.showDisplayView("error");
            // this.showDisplayView(`success`);
        });
    };
    // // Display
    FormItemRegistrationAchieva.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemRegistrationAchieva;
}(Base));
export { FormItemRegistrationAchieva };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-registration-achieva/form-item-registration-achieva.component.ts
// module id = 989
// module chunks = 0